import { View, Text, FlatList, Image, Touchable, TouchableOpacity, StatusBar, ActivityIndicator } from 'react-native'
import { Ionicons, Feather } from '@expo/vector-icons'
import React, { useEffect, useState } from 'react'
import { StackScreenProps } from '@react-navigation/stack'
import { DotsNavigation } from '../navigation/stacks/NavigationStack'
import { ScrollView } from 'react-native-gesture-handler'
import { CustomNumberPicker } from '../customUtils/CustomNumberPicker'
import { apiUrl } from '../../config/config'
import { fetchAuthSession } from 'aws-amplify/auth'
import { DateFormatter } from '../customUtils/DateFormatter'
import styles from './RedeemVoucherScreenStyles'
import { placeholderGeneral } from '../customUtils/Constants'
import { FlashList } from '@shopify/flash-list'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { Loader } from '../customUtils/Components/Loader'
import { BottomSheetAlert } from '../modals/BottomSheetAlert'
import theme from '../../../theme'
import { RedeemVoucherModel, RedeemVoucherProductModel } from './models/RedeemVoucherModel'

interface Props extends StackScreenProps<DotsNavigation, 'RedeemVoucher'> {}

export const RedeemVoucherScreen = ({
    data,
    closeRedeem,
    code_qr,
    updateSnapPoints,
    rejected,
}: {
    data: RedeemVoucherModel
    closeRedeem: () => void
    code_qr: string
    updateSnapPoints: (snapPoints: string[]) => void
    rejected: (title: string, desc: string) => void
}) => {
    const voucher = data
    const [products, setProducts] = useState<RedeemVoucherProductModel[]>(voucher.products ?? [])
    const [totalSelected, setTotalSelected] = useState(0)
    const [status, setStatus] = useState(0)
    const [showModal, setShowModal] = useState(false)
    const [loading, setLoading] = useState(true)
    const voucherMin = voucher.min ?? 0
    const voucherMax = voucher.max ?? 100
    useEffect(() => {
        setLoading(false)
    }, [products])
    const updateVoucher = (product: RedeemVoucherProductModel) => {
        const newProducts = products.map((item) => (item._id === product._id ? product : item))
        setProducts(newProducts)
        setTotalSelected(newProducts.reduce((acc, item) => acc + (item.quantity ?? 0), 0))
    }

    const redeemVoucher = async () => {
        if (totalSelected < voucherMin) {
            return alert(`No alcanzaste las cantidades mínimas permitidas: ${voucherMin}`)
        }
        if (totalSelected > voucherMax) {
            return alert(`Te excediste de las cantidades máximas permitidas: ${voucherMax}`)
        }
        try {
            const session = await fetchAuthSession()
            const authToken = session.tokens?.accessToken?.toString() || ""
            let headers = {
                'Content-Type': 'application/json',
                Authorization: authToken,
                benefit_id: voucher._id,
            }
            const newProducts = products.map((item) => {
                return {
                    _id: item._id,
                    quantity: item.quantity,
                }
            })

            let body = {
                products: newProducts,
                code_qr: code_qr,
            }
            const response = await fetch(`${apiUrl}/redeem_benefit`, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(body),
            })
            console.log(body)

            if (!response.ok) {
                const errorResponse = await response.json()
                throw new Error(`Fallo al agregar el voucher. Código de estado: ${response.status}. Detalles: ${JSON.stringify(errorResponse)}`)
            }

            const data = await response.json()
            // console.log(data)
            if (data.single.status === 1) {
                // Beneficio redimido con éxito
                setStatus(1)
                // updateSnapPoints(['45%'])
                setShowModal(true)
            } else if (data.single.status === -1) {
                setStatus(-1)
                // updateSnapPoints(['45%'])
                setShowModal(true)
            } else if (data.single.status === 0) {
                const title = data.single.message
                const desc = data.single.description
                console.log('🚀 ~ RedeemVoucher ~ title:', title)
                rejected(title, desc)
            }
        } catch (error) {
            console.log('🚀 ~ redeemBenefit ~ error:', error)
            updateSnapPoints(['45%'])
            setStatus(-1)
            setShowModal(true)
        }
    }

    const { languageFile } = getLanguage()

    return !showModal ? (
        <>
            {!loading ? (
                <View style={styles.container}>
                    <ScrollView nestedScrollEnabled={true} showsVerticalScrollIndicator={false} style={{ flex: 1 }}>
                        <Text style={styles.header}>{languageFile.complete_to_redeem_the_voucher}</Text>
                        <Text style={styles.subHeader}>
                            Selecciona las cantidades de productos que necesitas para canjear tu voucher, teniendo en cuenta los límites mínimos y
                            máximos permitidos para cada artículo.
                        </Text>
                        <View style={{ flexDirection: 'row', justifyContent: 'space-around', paddingHorizontal: 15 }}>
                            <Text style={styles.counter}>{'Total Mín: ' + voucherMin}</Text>
                            <Text style={styles.counter}>{'Total Máx: ' + voucherMax}</Text>
                        </View>

                        {/* <FlatList
                        data={products}
                        keyExtractor={(item) => item._id}
                        horizontal={false}
                        showsHorizontalScrollIndicator={false}
                        showsVerticalScrollIndicator={false}
                        renderItem={({ item: product }) => <RedeemVoucherItem item={product} updateProducts={updateVoucher} />}
                        /> */}
                        {products.length > 0 && (
                            <View style={{ paddingVertical: 15 }}>
                                {products.map((product) => (
                                    <RedeemVoucherItem key={product._id} item={product} updateProducts={updateVoucher} />
                                ))}
                            </View>
                        )}
                    </ScrollView>
                    <View style={styles.containerData}>
                        <View style={{ flexDirection: 'row' }}>
                            <Text style={styles.info}>{languageFile.valid_until}</Text>
                            <Text style={styles.info}>{DateFormatter({ date: voucher.date_finish })}</Text>
                        </View>

                        <View style={{ flexDirection: 'row' }}>
                            <Text style={styles.detail}>{languageFile.quantity_purchased}</Text>
                            <Text style={[styles.detail, { fontWeight: 'bold' }]}>{totalSelected}</Text>
                        </View>
                        <View style={styles.spacer}></View>
                    </View>
                    <View style={styles.buttonContainer}>
                        <TouchableOpacity onPress={() => redeemVoucher()} style={styles.mainButton}>
                            <Text style={styles.mainButtonText}>{languageFile.redeem}</Text>
                        </TouchableOpacity>
                    </View>
                </View>
            ) : (
                <Loader />
            )}
        </>
    ) : (
        <BottomSheetAlert
            image={status == 1 ? require('../../../assets/camera_voucher_check.png') : require('../../../assets/voucherCancelled.png')}
            title={status == 1 ? languageFile.voucher_redeemed : languageFile.error_redeeming_voucher}
            button={languageFile.back}
            desc={'Gracias por confiar en nosotros y\naprovechar esta oportunidad.\n¡Esperamos que disfrutes tu beneficio!'}
            closeBottomSheet={() => closeRedeem()}
        />
    )
}

export const RedeemVoucherItem = ({
    item,
    updateProducts,
}: {
    item: RedeemVoucherProductModel
    updateProducts: (item: RedeemVoucherProductModel) => void
}) => {
    const { languageFile } = getLanguage()

    const [productQuantity, setQuantity] = useState(item.quantity ?? item.min ?? 0)

    const changeValue = (value: number) => {
        if (value < item.min) {
            setQuantity(item.min)
            updateProducts({ ...item, quantity: item.min })
        } else if (value > item.max) {
            setQuantity(item.max)
            updateProducts({ ...item, quantity: item.max })
        } else {
            setQuantity(value)
            updateProducts({ ...item, quantity: value })
        }
    }
    return (
        <View>
            {/* <StatusBar backgroundColor={'rgba(0, 0, 0, 0.7)'} barStyle='dark-content' /> */}
            <View style={styles.containerItem}>
                {item.medias && (
                    <View style={{ flex: 1 }}>
                        <FlashList
                            data={item.medias}
                            keyExtractor={(item, index) => index.toString()}
                            horizontal={true}
                            showsHorizontalScrollIndicator={false}
                            renderItem={({ item: media }) => (
                                <Image source={{ uri: media.media_url ? media.media_url : placeholderGeneral }} style={styles.image} />
                            )}
                        />
                    </View>
                )}

                <View style={styles.containerInfo}>
                    {item.title && <Text style={styles.title}>{item.title}</Text>}
                    {item.description && <Text style={styles.description}>{item.description}</Text>}

                    <View style={styles.containerMinMax}>
                        <Text style={styles.counter}>{'Mín: '}</Text>
                        <Text style={styles.number}>{item.min}</Text>
                        <Text style={styles.counter}>{'  Máx: '}</Text>
                        <Text style={styles.number}>{item.max}</Text>
                    </View>
                </View>

                <View style={styles.containerNumberPicker}>
                    <TouchableOpacity style={styles.containerSign} onPress={() => changeValue(productQuantity - 1)}>
                        <Feather name='minus' size={20} color={theme.colors.textPrimary} style={styles.sign} />
                    </TouchableOpacity>
                    <Text style={[styles.number, { fontSize: 18, paddingHorizontal: 6 }]}>{productQuantity}</Text>
                    <TouchableOpacity
                        style={[styles.containerSign, { backgroundColor: theme.colors.colorPrimary }]}
                        onPress={() => changeValue(productQuantity + 1)}
                    >
                        <Feather name='plus' size={20} color={'white'} style={styles.sign} />
                    </TouchableOpacity>
                </View>
            </View>
            <View style={styles.dividerHorizontalLine}></View>
        </View>
    )
}

export const RedeemModal = ({ status, closeBottomSheet }: { status: number; closeBottomSheet: (l) => void }) => {
    const { languageFile } = getLanguage()
    const image = status == 1 ? require('../../../assets/voucherRedeemed.png') : require('../../../assets/voucherCancelled.png')
    const message = status == 1 ? languageFile.voucher_redeemed : languageFile.error_redeeming_voucher
    return (
        <View>
            <View>
                <View>
                    <Image source={image} />
                </View>

                <Text>{message}</Text>

                <Text>{message}</Text>
            </View>
            <TouchableOpacity onPress={() => closeBottomSheet(true)}>
                <Text>{languageFile.back_to_store}</Text>
            </TouchableOpacity>
        </View>
    )
}
